import { getAspectRatioStyle } from "@common/controls/AspectRatioContainer/lib";
import classnames from "classnames";
import { isUndefined } from "lodash";
import * as React from "react";
import { type VideoProps } from "../component";

export type HTMLVideoProps = VideoProps & {
  className?: string;
};

class HtmlVideo extends React.PureComponent<HTMLVideoProps> {
  private _ref = React.createRef<HTMLVideoElement>();

  public static defaultProps: Partial<HTMLVideoProps> = {
    showControls: true
  };

  public componentDidMount() {
    this._setSource(this.props);
  }

  public componentDidUpdate(prevProps: Readonly<HTMLVideoProps>) {
    this._setSource(this.props);
  }

  public render() {
    const props = this.props;
    return (
      <div
        className={classnames("video_container", { background: props.isBackground })}
        style={getAspectRatioStyle(props.aspectRatio)}
      >
        <div className={classnames("video html_video", props.className)}>
          <video
            ref={this._ref}
            autoPlay={props.autoPlay || props.isBackground}
            controls={(props.showControls || isUndefined(props.showControls)) && !props.isBackground}
            loop={props.loop || props.isBackground}
            muted={props.autoPlay || props.mute || props.isBackground}
          />
        </div>
      </div>
    );
  }

  private _setSource = (props: HTMLVideoProps) => {
    const videoEl = this._ref.current!;

    videoEl.setAttribute("src", props.url ?? "");
    videoEl.load();
  };
}

export default HtmlVideo;
